module.exports = __webpack_public_path__ + "static/v-strip-fb79e16c1b12f8f726940ccba72caa38.jpg";